import {useQuery} from '@tanstack/react-query'

import {getFeatures} from '../../api/endpoints'

export const getFeaturesQueryKey = (plantUpmId?: string): string[] =>
  plantUpmId ? ['features', plantUpmId] : ['features']

export const useFeatures = ({plantUpmId}: {plantUpmId?: string} = {}) => {
  return useQuery({
    queryKey: getFeaturesQueryKey(plantUpmId),
    queryFn: async () => {
      const response = await getFeatures(plantUpmId)
      return response.data
    },
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 5 // 5 minutes
  })
}
